import gql from 'graphql-tag'

export default gql`
mutation deleteProductList($id: ID!) {
	cashAssist {
		deleteProductList(id: $id) {
			id
		}
	}
}
`
